module.exports = __webpack_public_path__ + "mainassets/img/form_5.a28cdd60.svg";